// TODO: Remove after separeting qrcodes from main app
import { Router } from '@reach/router'
import React from 'react'

import { useLocation } from '../../utils/contexts/UrlProvider'

const MainRouterWrapper = ({ children }) => {
  const { pathname } = useLocation()

  if (pathname.startsWith('/qrcodes')) {
    return false
  }

  return <Router className="router">{children}</Router>
}

export default MainRouterWrapper
